<template>
  <div class="row align-items-center">
    <div class="col">
      <p>
        <span class="dash-ope__type user-dash__badge badge font-size-normal mb-1 mr-2" :class="'badge-outline-' + $mainColor">
          {{ intervention.formatted_kind }}
        </span>
        <span class="dash-ope__id user-dash__badge badge badge-primary font-size-normal">
          #{{ intervention.id }}
        </span>
        <br />
        <span class="dash-ope__id user-dash__badge badge badge-warning" v-if="intervention.no_report">
          Rapport en attente
        </span>
      </p>
      <p class="mb-0">
        {{ intervention.formatted_label }}
      </p>
      <p class="mb-0" :class="'text-' + $mainColor" v-if="intervention.resolved_at">
        {{ intervention.formatted_resolved_at }}
      </p>
      <p class="mb-0" :class="'text-' + $mainColor" v-else-if="intervention.realized_at">
        {{ intervention.formatted_realized_at }}
      </p>
      <p class="mb-0" :class="'text-' + $mainColor" v-else>
        {{ intervention.formatted_created_at }}
      </p>
    </div>
    <div class="col-auto ml-auto" v-if="buttons">
      <button
        v-if="!intervention.realized_at"
        type="button"
        :class="'btn-outline-' + $mainColor"
        class="btn thin mr-2">
        Marquer comme réalisée
      </button>
      <button
        v-if="collapsible"
        type="button"
        class="btn thin collapsed"
        :class="'btn-' + $mainColor"
        data-toggle="collapse"
        :data-target="'#ope1Details' + intervention.id"
        aria-expanded="false"
        :aria-controls="'ope1Details' + intervention.id">
        Détails
        <i class="bestove-icon__arrow-top ml-h"></i>
      </button>
      <router-link
        v-if="!collapsible"
        :to="{ name: 'interventions', query: { id: intervention.id } }"
        class="btn thin px-md-5"
        :class="'btn-' + $mainColor">
        Voir
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InterventionHeader',
  props: {
    intervention: {
      type: Object,
      default: () => {}
    },
    buttons: {
      type: Boolean,
      default: true
    },
    collapsible: {
      type: Boolean,
      default: false
    }
  }
}
</script>
